var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78556 2.50033C8.07889 2.86699 8.32333 3.27644 8.50667 3.72255H11V5.55588H8.86111C8.86111 8.25088 6.66722 10.4448 3.97222 10.4448H3.465L9.31333 15.3337H6.44722L0 9.97421V8.61144H3.97222C5.65889 8.61144 7.02778 7.24255 7.02778 5.55588H0V3.72255H6.41667C5.86056 2.9831 4.96833 2.50033 3.97222 2.50033H0V0.666992H11V2.50033H7.78556Z",
    fill: "#EE4E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeIcon);
export default __webpack_public_path__ + "static/media/rupeeIcon.6ab372ed767d17d984a54501639f8c91.svg";
export { ForwardRef as ReactComponent };